import { useEffect, useContext } from "react"
import PropTypes from "prop-types"

import { useFormikContext } from "formik"
import { FormContext } from "../../../context/formContext"

import styles from "../../../styles/Form.module.css"

export default function AssessmentType({ field, block, index }) {
  const form = useContext(FormContext)
  const formik = useFormikContext()

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let assessmentType = ""
    if (block === "session__assessment_recovery_capital") {
      if (form.idTemplate === "ad_hoc_recovery_capital_assessment") {
        assessmentType = "ad_hoc_assessment"
      } else {
        assessmentType = form.idTemplate
      }
    }

    if (formik.values[field.field_name] !== assessmentType) {
      formik.setFieldValue(field.field_name, assessmentType)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values])

  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}

AssessmentType.propTypes = {
  field: PropTypes.shape({
    field_name: PropTypes.string.isRequired,
  }).isRequired,
  block: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
}
